// eslint-disable-next-line import/prefer-default-export
export const FILE_TYPE = 'file';
export const FOLDER_TYPE = 'folder';
export const QUERY_REFRESH_CURRENT_FOLDER = 'refreshCurrentFolder';
export const QUERY_REFRESH_HOME = 'refreshHome';
